
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload } from '@/components';
import { useLeagueTierAdd } from '@/modules/league/tier/model/add';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';

export default defineComponent({
    name: ROUTE_NAME_LEAGUE.TIER.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload },
    setup() {
        const { model, v$, create } = useLeagueTierAdd();

        return { v$, model, create };
    }
});
